import { fetchDropperFunnelStats } from '@/api/dropper-funnel';
import { formatDurationMs, type DropperFunnelStatsResponse } from '@/entities/dropper-funnel';
import DropperFunnelChart from '@/components/stats/dropper-funnel-chart';
import { Input } from '@/components/ui/input';
import { Spinner } from '@/components/ui/spinner';
import { Button } from '@/components/ui/button';
import { useState } from 'react';

export default function DropperFunnelSection() {
	const [buildId, setBuildId] = useState('');
	const [period, setPeriod] = useState<'7d' | '30d'>('7d');
	const [stats, setStats] = useState<DropperFunnelStatsResponse | null>(null);
	const [loading, setLoading] = useState(false);

	async function loadStats() {
		const trimmed = buildId.trim();
		if (!trimmed) return;
		setLoading(true);
		try {
			const data = await fetchDropperFunnelStats(trimmed, period);
			setStats(data);
		} catch {
			setStats(null);
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className='grid gap-2'>
			<div className='flex flex-wrap items-center gap-2'>
				<Input
					value={buildId}
					onChange={e => setBuildId(e.target.value)}
					placeholder='buildId'
					className='max-w-xs'
				/>
				<Button type='button' variant={period === '7d' ? 'default' : 'outline'} size='sm' onClick={() => setPeriod('7d')}>
					7д
				</Button>
				<Button type='button' variant={period === '30d' ? 'default' : 'outline'} size='sm' onClick={() => setPeriod('30d')}>
					30д
				</Button>
				<Button type='button' size='sm' onClick={loadStats} disabled={loading || !buildId.trim()}>
					Показать
				</Button>
			</div>
			{loading ? (
				<div className='flex justify-center py-8'>
					<Spinner />
				</div>
			) : stats ? (
				<div className='grid gap-2'>
					<p className='text-sm text-muted-foreground'>
						Медиана установки: {formatDurationMs(stats.medianInstallDurationMs)}
					</p>
					<DropperFunnelChart buildId={stats.buildId} funnel={stats.funnel} />
				</div>
			) : null}
		</div>
	);
}
